/* HuddleWarm bundle builder: native tier bundle widget.
 * Reads #bundle-builder-config, mounts into #bundle-builder, and builds the whole
 * cart in one /cart/add.js request. Tier totals are charged by automatic Shopify
 * discounts scoped to the product (no discount codes, by design).
 * Shipping protection is added by default unless the shopper switched it off in
 * the cart drawer (remembered in localStorage).
 */
(function () {
  'use strict';

  var MOUNT_ID = 'bundle-builder';
  var CONFIG_ID = 'bundle-builder-config';

  var root, cfg, state = { tier: 0, picks: [], addons: {} };

  function store(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      if (val === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  function money(cents) {
    var c = Math.round(cents);
    var amount = (c / 100).toFixed(2);
    var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (!cfg.moneyFormat) return '$' + withComma;
    return cfg.moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(c / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withComma);
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch];
    });
  }

  function tier() { return cfg.tiers[state.tier]; }

  function total() {
    var sum = tier().price;
    (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) sum += a.price; });
    return sum;
  }

  function unitOptions(selected) {
    return cfg.variants.map(function (v) {
      return '<option value="' + v.id + '"' +
        (String(v.id) === String(selected) ? ' selected' : '') +
        (v.available ? '' : ' disabled') + '>' +
        esc(v.title) + (v.available ? '' : ' (sold out)') + '</option>';
    }).join('');
  }

  function render() {
    var html = '';
    if (cfg.label) html += '<p class="bbdl__label">' + esc(cfg.label) + '</p>';

    cfg.tiers.forEach(function (tr, i) {
      var on = i === state.tier;
      html += '<div class="bbdl__tier' + (on ? ' is-on' : '') + '" data-tier="' + i + '">';
      if (tr.badge) html += '<span class="bbdl__badge">' + esc(tr.badge) + '</span>';
      html += '<label class="bbdl__head">';
      html += '<input type="radio" class="bbdl__radio" name="bbdl-tier" value="' + i + '"' + (on ? ' checked' : '') + '>';
      html += '<span class="bbdl__ht"><span class="bbdl__title">' + esc(tr.title) + '</span>';
      if (tr.subtitle) html += '<span class="bbdl__sub">' + esc(tr.subtitle) + '</span>';
      html += '</span>';
      html += '<span class="bbdl__pr"><span class="bbdl__price">' + money(tr.price) + '</span>';
      if (tr.compareAt && tr.compareAt > tr.price) html += '<span class="bbdl__was">' + money(tr.compareAt) + '</span>';
      html += '</span></label>';

      if (cfg.variants.length > 1) {
        html += '<div class="bbdl__body">';
        for (var u = 0; u < tr.qty; u++) {
          html += '<div class="bbdl__pick"><div class="bbdl__pickLabel">' +
            esc(tr.qty > 1 ? (cfg.unitWord || 'Item') + ' ' + (u + 1) : (cfg.pickLabel || 'Choose')) + '</div>';
          html += '<select class="bbdl__select" data-unit="' + u + '">' + unitOptions(state.picks[u]) + '</select></div>';
        }
        html += '</div>';
      }

      // Upsell rows live inside every card. Only the selected card's rows are
      // checkable; the others preview the same offers.
      if (cfg.addons && cfg.addons.length) {
        html += '<div class="bbdl__ups">';
        cfg.addons.forEach(function (a) {
          html += on ? '<label class="bbdl__up">' : '<div class="bbdl__up">';
          if (on) html += '<input type="checkbox" class="bbdl__cb" data-addon="' + a.id + '"' + (state.addons[a.id] ? ' checked' : '') + '>';
          if (a.image) html += '<img class="bbdl__thumb" src="' + esc(a.image) + '" alt="" loading="lazy" width="42" height="42">';
          html += '<span class="bbdl__an">+ ' + esc(a.label || a.title) + '</span>';
          html += '<span class="bbdl__ap">' + money(a.price) + '</span>';
          html += on ? '</label>' : '</div>';
        });
        html += '</div>';
      }
      html += '</div>';
    });

    html += '<div class="bbdl__total"><span>' + esc(cfg.totalLabel || 'Total') + '</span><b data-total></b></div>';
    html += '<button type="button" class="bbdl__cta">' + esc(cfg.ctaLabel || 'Add to cart') + '</button>';
    html += '<p class="bbdl__err">' + esc(cfg.errorText || 'Please try again.') + '</p>';

    root.innerHTML = html;
    paintTotal();
  }

  function paintTotal() {
    var el = root.querySelector('[data-total]');
    if (el) el.textContent = money(total());
  }

  function ready() {
    if (cfg.variants.length <= 1) return true;
    var t = tier();
    for (var i = 0; i < t.qty; i++) if (!state.picks[i]) return false;
    return true;
  }

  function onChange(e) {
    var el = e.target;
    if (el.name === 'bbdl-tier') { state.tier = parseInt(el.value, 10); render(); return; }
    if (el.hasAttribute('data-unit')) {
      state.picks[parseInt(el.getAttribute('data-unit'), 10)] = el.value;
      root.classList.remove('has-error');
      return;
    }
    if (el.hasAttribute('data-addon')) { state.addons[el.getAttribute('data-addon')] = el.checked; paintTotal(); }
  }

  function buildItems() {
    var t = tier(), items = [], counts = {};
    if (cfg.variants.length > 1) {
      for (var i = 0; i < t.qty; i++) counts[state.picks[i]] = (counts[state.picks[i]] || 0) + 1;
    } else {
      counts[cfg.variants[0].id] = t.qty;
    }
    Object.keys(counts).forEach(function (id) { items.push({ id: Number(id), quantity: counts[id] }); });
    (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) items.push({ id: Number(a.id), quantity: 1 }); });
    return items;
  }

  function protectionWanted(cart) {
    if (!cfg.protection || !cfg.protection.id) return false;
    if (store(cfg.protection.optOutKey) === '1') return false;
    return !(cart.items || []).some(function (it) { return String(it.variant_id || it.id) === String(cfg.protection.id); });
  }

  function openDrawer(parsed) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && parsed && parsed.sections) {
      try { drawer.renderContents(parsed); return true; } catch (e) {}
    }
    return false;
  }

  function addToCart() {
    var btn = root.querySelector('.bbdl__cta');
    if (!ready()) { root.classList.add('has-error'); return; }
    root.classList.remove('has-error');
    btn.disabled = true;

    var items = buildItems();
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try { sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) { sections = []; }
    }

    fetch((cfg.routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        if (protectionWanted(cart)) items.push({ id: Number(cfg.protection.id), quantity: 1 });
        var body = { items: items };
        if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
        return fetch(cfg.routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || res.d.status) throw new Error(res.d.description || 'add failed');
        if (cfg.afterAdd === 'drawer' && openDrawer(res.d)) { btn.disabled = false; return; }
        window.location.href = cfg.afterAdd === 'checkout' ? cfg.routes.checkout : cfg.routes.cart;
      })
      .catch(function () {
        btn.disabled = false;
        root.classList.add('has-error');
      });
  }

  // Remember the shopper's shipping-protection choice from the cart drawer toggle.
  function watchProtectionToggle() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!cfg.protection || !t || !t.closest || !t.closest('.gb-shipping-protection-button')) return;
      store(cfg.protection.optOutKey, t.checked ? null : '1');
    }, true);
  }

  function boot() {
    root = document.getElementById(MOUNT_ID);
    var node = document.getElementById(CONFIG_ID);
    if (!root || !node) return;
    try { cfg = JSON.parse(node.textContent); } catch (e) { return; }
    if (!cfg.tiers || !cfg.tiers.length || !cfg.variants || !cfg.variants.length) return;

    // When the sale end time has passed, swap every tier to its post-sale values
    // (regular price, no savings copy) so the widget matches what Shopify charges.
    // A one-day promo window overrides tier prices/copy while it is running.
    var now = Date.now(), promo = cfg.promo;
    var promoOn = promo && now >= Date.parse(promo.startsAt) && now < Date.parse(promo.endsAt);
    if (promoOn) {
      (promo.tiers || []).forEach(function (o, i) { if (o && cfg.tiers[i]) { for (var k in o) cfg.tiers[i][k] = o[k]; } });
      if (promo.label !== undefined) cfg.label = promo.label;
      if (typeof promo.defaultTier === 'number' && cfg.tiers[promo.defaultTier]) state.tier = promo.defaultTier;
    }
    var saleEnd = cfg.saleEndsAt ? Date.parse(cfg.saleEndsAt) : NaN;
    if (!promoOn && saleEnd && now >= saleEnd) {
      cfg.tiers.forEach(function (t) { if (t.afterSale) { for (var k in t.afterSale) t[k] = t.afterSale[k]; } });
      if (cfg.labelAfterSale !== undefined) cfg.label = cfg.labelAfterSale;
    }

    var first = cfg.variants.filter(function (v) { return v.available; })[0] || cfg.variants[0];
    var maxQty = cfg.tiers.reduce(function (m, t) { return Math.max(m, t.qty); }, 1);
    state.picks = new Array(maxQty).fill(first.id);
    (cfg.addons || []).forEach(function (a) { state.addons[a.id] = !!a.checked; });

    root.classList.add('bbdl');
    render();
    root.addEventListener('change', onChange);
    root.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('.bbdl__cta')) { addToCart(); return; }
      // Clicking anywhere on an unselected card selects that tier.
      var card = e.target.closest('.bbdl__tier');
      if (card && !card.classList.contains('is-on') && !e.target.closest('.bbdl__radio')) {
        state.tier = parseInt(card.getAttribute('data-tier'), 10);
        render();
      }
    });
    watchProtectionToggle();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
